const { PRODUCTION_ENVIRONMENT, OCULTO_ENVIRONMENT } = require('constants/index');
//PASSWORD is already encrypted
let mortgageTPVIframe = {
    MERCHANT_MERCHANTCODE: 'bdwqfc8z',
    MERCHANT_TERMINAL: '6332',
    OPERATION: '1',
    MERCHANT_CURRENCY: 'EUR',
    PASSWORD: '2548566b468c00d50eecd5fa2ef56d16',
    SECURE: '1'
};

if (window.__ENV__ !== PRODUCTION_ENVIRONMENT && window.__ENV__ !== OCULTO_ENVIRONMENT) {
    mortgageTPVIframe = {
        MERCHANT_MERCHANTCODE: 'x95jmwbg',
        MERCHANT_TERMINAL: '5401',
        OPERATION: '1',
        MERCHANT_CURRENCY: 'EUR',
        PASSWORD: '226c919fd8e543beb83e46f7faa3ca7b'
    };
}
module.exports = { mortgageTPVIframe };

